import React from "react";
import { Modal } from "react-bootstrap";
import { EmployeeInformation } from "../EmployeeInformation/EmployeeInfo";
import { EmployeeDataList } from "./EmployeeDataList";
export const EmployeeInfoModal=(props:any)=>{
    return(
        <div>
        <Modal.Header closeButton >
          <Modal.Title>{props.title}</Modal.Title> 
        </Modal.Header>
        <Modal.Body>
        <EmployeeInformation id={props.id}/>
        </Modal.Body>
        </div>
    )
}